<template>
  <div class="entering-wrapper">
    <!-- <entering-step :step="step" stepOneText="个人信息" stepTwoText="线下首诊信息" /> -->
    <!-- 第一部分 -->
    <div class="form-wrapper">
      <!-- 真实姓名 -->
      <div class="form-item click" :class="{'error': realNameError}">
        <div class="form-type"><span class="required">真实姓名</span></div>
        <div class="form-content">
          <input type="text" class="form-text" placeholder="请输入姓名" v-model="realName" :disabled="hasName">
        </div>
        <div class="form-error" v-if="realNameError">
          <van-icon name="fail" />{{realNameErrorMsg}}</div>
      </div>
      <!-- 性别 -->
      <div class="form-item click" :class="{'error': genderError}" @click="pickGender">
        <div class="form-type"><span class="required">性别</span></div>
        <div class="form-content" :class="{'disabled': hasGender}">
          <div class="picker-tips" v-if="!gender">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{this.gender | sexFilter}}</div>
        </div>
        <div class="form-error" v-if="genderError">
          <van-icon name="fail" />{{genderErrorMsg}}</div>
      </div>
      <!-- 身份证号 -->
    <div class="form-item click" :class="{'error': IDNumberError}">
        <div class="form-type"><span class="required">身份证号</span></div>
        <div class="form-content">
          <input type="text" class="form-text" placeholder="请输入" v-model="IDNumber" :disabled="hasIDNumber">
        </div>
        <div class="form-error" v-if="IDNumberError"><van-icon name="fail" />{{IDNumberErrorMsg}}</div>
      </div>
      <!-- 出生年月 -->
      <div class="form-item click" @click="showBornPicker">
        <div class="form-type"><span class="required">出生年月</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!born">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{born | parseDateToMonth}}</div>
        </div>
      </div>
      <!-- 身高 -->
      <!-- <div class="form-item click">
        <div class="form-type"><span class="required">身高(cm)</span></div>
        <div class="form-content">
          <input type="number" class="form-text" placeholder="请输入" v-model="height">
        </div>
      </div> -->
      <!-- 体重 -->
      <!-- <div class="form-item click">
        <div class="form-type"><span class="required">体重(kg)</span></div>
        <div class="form-content">
          <input type="number" class="form-text" placeholder="请输入" v-model="weight">
        </div>
      </div> -->
      <!-- BMI -->
      <!-- <div class="form-item">
        <div class="form-type"><span class="required">BMI</span></div>
        <div class="form-content">
          <div class="bmi-value" :class="{'has-value': bmi > 0}">{{bmi}}</div>
        </div>
      </div> -->
      <!-- 过敏史 -->
      <div class="form-item click" :class="{'editable-item': allergy == '有'}" @click="allergyPickerShow = true">
        <div class="form-type"><span class="required">过敏史</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!allergy">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{allergy}}</div>
        </div>
      </div>
      <div class="allergy-textarea" v-if="allergy == '有'">
        <textarea class="form-textarea" placeholder="如有过敏史请说明" v-ios-bug-fixed v-model="allergyText" maxlength="100"></textarea>
        <span class="textarea-limit">{{allergyText.length}}/100</span>
      </div>
      <!-- 所在地 -->
      <div class="form-item click" @click="areaPickerShow = true">
        <div class="form-type"><span class="required">所在地</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!location.province">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{location.province}}</div>
        </div>
      </div>
      <!-- 婚况 -->
      <!-- <div class="form-item click" @click="marriagePickerShow = true">
        <div class="form-type"><span>婚况</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!marriage">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{marriage | marriageFilter}}</div>
        </div>
      </div> -->
      <!-- 是否生育 -->
      <!-- <div class="form-item click" @click="parentalPickerShow = true">
        <div class="form-type"><span>是否生育</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!parental">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{parental | parentalFilter}}</div>
        </div>
      </div> -->
      <!-- 民族 -->
      <!-- <div class="form-item click" @click="nationalityPickerShow = true">
        <div class="form-type"><span>民族</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!nationality">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{nationality}}</div>
        </div>
      </div> -->
      <!-- 职业 -->
      <!-- <div class="form-item click" @click="jobPickerShow = true">
        <div class="form-type"><span>职业</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!job">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{job}}</div>
        </div>
      </div> -->
    </div>
    <!-- 第二部分 -->
    <div class="form-wrapper">
      <div class="form-item" :class="{'error': phoneError}">
        <div class="form-type"><span class="required">手机号</span></div>
        <div class="form-content">
          <input type="text" class="form-text" placeholder="请输入" v-model="phone" :disabled="bindedPhone">
        </div>
        <div class="form-error" v-if="phoneError">
          <van-icon name="fail" />{{phoneErrorMsg}}</div>
      </div>
      <div class="form-item" v-if="!bindedPhone">
        <div class="code-input-box"><input type="number" class="code-input" v-model="code" @input="codeChange"
            placeholder="请输入验证码"></div>
        <div class="form-content">
          <button class="get-code-button" @click="countdown" :disabled="sandingCode">
            <span v-if="sandingCode">已发送 {{time}}s</span>
            <span v-else>获取验证码</span>
          </button>
        </div>
      </div>
    </div>
    <div class="submit-box"><button class="submit-button" @click="nextStep" :disabled="submitting">完成绑定</button></div>

    <!-- 弹出层 -->
    <!-- 所在地选择 -->
    <van-popup v-model="areaPickerShow" position="bottom">
      <van-area :area-list="areaList" :columns-num="1" title="所在地区" @cancel="areaPickerShow = false" @confirm="confirmLocation" />
    </van-popup>
    <!-- 性别选择 -->
    <van-popup v-model="genderPickerShow" position="bottom">
      <van-picker show-toolbar :columns="genderData" value-key="label" @cancel="genderPickerShow = false" @confirm="confirmGender" />
    </van-popup>
    <!-- 出生年月选择 -->
    <van-popup v-model="bornPickerShow" position="bottom">
      <van-datetime-picker show-toolbar type="year-month" v-model="born" :formatter="formatter" :max-date="maxDate"
        :min-date="minDate" @cancel="bornPickerShow = false" @confirm="confirmBirthday" />
    </van-popup>
    <!-- 过敏史选择 -->
    <van-popup v-model="allergyPickerShow" position="bottom">
      <van-picker show-toolbar :columns="allergyOptions" @cancel="allergyPickerShow = false" @confirm="confirmAllergy" />
    </van-popup>
    <!-- 婚况选择 -->
    <van-popup v-model="marriagePickerShow" position="bottom">
      <van-picker show-toolbar :columns="marriageOptions" value-key="label" @cancel="marriagePickerShow = false"
        @confirm="confirmMarriage" />
    </van-popup>
    <!-- 生育状况选择 -->
    <van-popup v-model="parentalPickerShow" position="bottom">
      <van-picker show-toolbar :columns="parentalOptions" value-key="label" @cancel="parentalPickerShow = false"
        @confirm="confirmParental" />
    </van-popup>
    <!-- 民族选择 -->
    <van-popup v-model="nationalityPickerShow" position="bottom">
      <van-picker show-toolbar :columns="nationalityOptions" value-key="name" @cancel="nationalityPickerShow = false"
        @confirm="confirmNationality" />
    </van-popup>
    <!-- 职业选择 -->
    <van-popup v-model="jobPickerShow" position="bottom">
      <van-picker show-toolbar :columns="jobOptions" @cancel="jobPickerShow = false" @confirm="confirmJob" />
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .entering-wrapper{
    background: #F7F7F7;
    padding-top: 1px;
    min-height: 100vh;
  }
  .form-wrapper{
    padding: 24px 0 12px;
    margin-top: 12px;
    background: #FFF;
    .form-item{
      position: relative;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      height: 40px;
      margin-bottom: 16px;
      transition: all .1s;
      &.vertical{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        .form-content{
          position: relative;
          width: 100%;
          margin-top: 16px;
          .form-textarea{
            border: 1px solid #F7F7F7;
            background: #F7F7F7;
            resize: none;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: #666;
            width: 100%;
            height: 144px;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .textarea-limit{
            position: absolute;
            right: 8px;
            bottom: 8px;
            font-size: 12px;
            color: #999;
          }
        }
      }
      &.avatar{
        height: 80px;
        margin-bottom: 12px;
      }
      &.click{
        cursor: pointer;
        &:active{
          background: #F9F9F9;
        }
      }
      &.error{
        margin-bottom: 28px;
        .form-content .form-text{
          color: @error;
        }
      }
      &.editable-item{
        margin-bottom: 0;
      }
      .form-type{
        font-size: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        .tips{
          margin-top: 6px;
          font-size: 12px;
          color: @xile;
        }
      }
      .form-content{
        color: #666;
        font-size: 16px;
        &.disabled .picker-value{
          color: #999;
        }
        .avatar-box{
          width: 64px;
          height: 64px;
          img{
            width: 100%;
          }
        }
        .form-text{
          width: 200px;
          border: 0;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
          &:disabled{
            -webkit-text-fill-color: #999;
            -webkit-opacity: 1;
            color: #999;
          }
        }
        .picker-tips{
          font-size: 16px;
          color: #999;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          svg{
            color: #CCC;
            position: relative;
            top: 2px;
            font-size: 14px;
            margin-left: 4px;
          }
        }
        .picker-value{
          max-width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .get-code-button{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 32px;
          border: 1px solid @xile;
          color: @xile;
          font-weight: bold;
          background: transparent;
          font-size: 12px;
          border-radius: 4px;
          transition: all .1s;
          &:disabled{
            border-color: #CCC;
            color: #CCC;
            &:active{
              opacity: 1;
            }
          }
          &:active{
            opacity: .8;
          }
        }
      }
      .code-input-box{
        .code-input{
          width: 200px;
          border: 0;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
      }
      .form-error{
        position: absolute;
        right: 16px;
        top: 100%;
        font-size: 12px;
        color: @error;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .van-icon{
          position: relative;
          top: 1px;
          width: 12px;
          height: 12px;
          background: @error;
          color: #FFF;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
    }
  }
  .allergy-textarea{
    position: relative;
    padding: 0 16px;
    width: 100%;
    .form-textarea{
      border: 1px solid #F7F7F7;
      background: #F7F7F7;
      resize: none;
      padding: 12px;
      font-size: 14px;
      line-height: 20px;
      color: #666;
      width: 100%;
      height: 96px;
      &::-webkit-input-placeholder{
        color: #999;
      }
    }
    .textarea-limit{
      position: absolute;
      right: 24px;
      bottom: 8px;
      font-size: 12px;
      color: #999;
    }
  }
  .submit-box{
    padding: 24px 16px 12px;
    .submit-button{
      @button-base();
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
</style>

<script type="text/javascript">
  import areaList from '@/untils/area'

  import enteringStep from '@/components/Common/enteringStep'
  export default {
    data() {
      return {
        submitting: false,
        step: 1,
        // 真实姓名
        realName: '',
        realNameError: false,
        realNameErrorMsg: '请输入真实姓名',
        // 是否已有姓名
        hasName: false,
        // 性别
        gender: '',
        genderError: false,
        genderErrorMsg: '请选择性别',
        genderData: [{
            label: '男',
            value: 1
          },
          {
            label: '女',
            value: 2
          },
        ],
        genderPickerShow: false,
        // 已有性别
        hasGender: false,
        // 身份证号
        IDNumber: '',
        IDNumberError: false,
        IDNumberErrorMsg: '请输入身份证号',
        // 所在地
        areaList,
        location: {
          province: '',
          city: ''
        },
        areaPickerShow: false,
        // 已有身份证号
        hasIDNumber: false,
        // 出生年月
        born: null,
        bornPickerShow: false,
        // 年月最大值
        maxDate: new Date(),
        minDate: new Date(1900, 1, 1),
        // 身高
        height: null,
        // 体重
        weight: null,
        // 有无过敏史
        allergy: '',
        allergyText: '',
        allergyPickerShow: false,
        allergyOptions: ['有', '否认', '不确定'],
        // 婚况
        marriage: '',
        marriagePickerShow: false,
        marriageOptions: [{
          label: '已婚',
          value: 1
        }, {
          label: '未婚',
          value: 2
        }],
        // 生育情况
        parental: '',
        parentalPickerShow: false,
        parentalOptions: [{
          label: '已育',
          value: 1
        }, {
          label: '未育',
          value: 2
        }],
        // 民族
        nationality: '',
        nationalityPickerShow: false,
        nationalityOptions: [{
            id: 1,
            name: '汉族'
          },
          {
            id: 2,
            name: '蒙古族'
          },
          {
            id: 3,
            name: '回族'
          },
          {
            id: 4,
            name: '藏族'
          },
          {
            id: 5,
            name: '维吾尔族'
          },
          {
            id: 6,
            name: '苗族'
          },
          {
            id: 7,
            name: '彝族'
          },
          {
            id: 8,
            name: '壮族'
          },
          {
            id: 9,
            name: '布依族'
          },
          {
            id: 10,
            name: '朝鲜族'
          },
          {
            id: 11,
            name: '满族'
          },
          {
            id: 12,
            name: '侗族'
          },
          {
            id: 13,
            name: '瑶族'
          },
          {
            id: 14,
            name: '白族'
          },
          {
            id: 15,
            name: '土家族'
          },
          {
            id: 16,
            name: '哈尼族'
          },
          {
            id: 17,
            name: '哈萨克族'
          },
          {
            id: 18,
            name: '傣族'
          },
          {
            id: 19,
            name: '黎族'
          },
          {
            id: 20,
            name: '傈僳族'
          },
          {
            id: 21,
            name: '佤族'
          },
          {
            id: 22,
            name: '畲族'
          },
          {
            id: 23,
            name: '高山族'
          },
          {
            id: 24,
            name: '拉祜族'
          },
          {
            id: 25,
            name: '水族'
          },
          {
            id: 26,
            name: '东乡族'
          },
          {
            id: 27,
            name: '纳西族'
          },
          {
            id: 28,
            name: '景颇族'
          },
          {
            id: 29,
            name: '柯尔克孜族'
          },
          {
            id: 30,
            name: '土族'
          },
          {
            id: 31,
            name: '达翰尔族'
          },
          {
            id: 32,
            name: '么佬族'
          },
          {
            id: 33,
            name: '羌族'
          },
          {
            id: 34,
            name: '布朗族'
          },
          {
            id: 35,
            name: '撒拉族'
          },
          {
            id: 36,
            name: '毛南族'
          },
          {
            id: 37,
            name: '仡佬族'
          },
          {
            id: 38,
            name: '锡伯族'
          },
          {
            id: 39,
            name: '阿昌族'
          },
          {
            id: 40,
            name: '普米族'
          },
          {
            id: 41,
            name: '塔吉克族'
          },
          {
            id: 42,
            name: '怒族'
          },
          {
            id: 43,
            name: '乌孜别克族'
          },
          {
            id: 44,
            name: '俄罗斯族'
          },
          {
            id: 45,
            name: '鄂温克族'
          },
          {
            id: 46,
            name: '德昂族'
          },
          {
            id: 47,
            name: '保安族'
          },
          {
            id: 48,
            name: '裕固族'
          },
          {
            id: 49,
            name: '京族'
          },
          {
            id: 50,
            name: '塔塔尔族'
          },
          {
            id: 51,
            name: '独龙族'
          },
          {
            id: 52,
            name: '鄂伦春族'
          },
          {
            id: 53,
            name: '赫哲族'
          },
          {
            id: 54,
            name: '门巴族'
          },
          {
            id: 55,
            name: '珞巴族'
          },
          {
            id: 56,
            name: '基诺族'
          },
        ],
        // 职业
        job: '',
        jobPickerShow: false,
        jobOptions: ['国家机关、党群组织、企业、事业单位负责人', '专业技术人员', '办事人员和有关人员', '商业、服务业人员', '农、林、牧、渔、水利业生产人员', '生产、运输设备操作人员及有关人员',
          '军人', '其他从业人员'
        ],
        // 手机号
        phone: '',
        phoneError: false,
        phoneErrorMsg: '请输入手机号',
        // 绑定过手机号只显示不能修改
        bindedPhone: false,
        // 验证码
        code: '',
        codeError: false,
        codeErrorMsg: '请输入验证码',
        // 倒计时
        countDownTimer: null,
        time: 60,
        sandingCode: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      // BMI计算
      bmi() {
        if (+this.height && +this.weight) {
          let heightM = this.height / 100;
          let bmiValue = this.weight / (heightM * heightM)
          return bmiValue.toFixed(1);
        }
        return '0.0';
      }
    },
    created() {
      // this.echoData();
    },
    beforeDestroy() {
      clearInterval(this.countDownTimer);
    },
    watch: {
      realName(val) {
        if ($.trim(val) == '') {
          this.realNameError = true
          this.realNameErrorMsg = '请输入真实姓名'
        } else if (!/^([\u4e00-\u9fa5·]{2,10})$/.test($.trim(val))) {
          this.realNameError = true
          this.realNameErrorMsg = '请输入正确的姓名'
        } else {
          this.realNameError = false
        }
      },
      IDNumber(val) {
        if ($.trim(val) == '') {
          this.IDNumberError = true
          this.IDNumberErrorMsg = '请输入身份证号'
        } else if (!/^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$/.test($.trim(val))) {
          this.IDNumberError = true
          this.IDNumberErrorMsg = '请输入正确的身份证号'
        } else {
          this.IDNumberError = false
        }
      },
      exp(val) {
        if ($.trim(val) == '') {
          this.expError = true
          this.expErrorMsg = '请填写医生简介'
        } else {
          this.expError = false
        }
      },
      phone(val) {
        if ($.trim(val) == '') {
          this.phoneError = true
          this.phoneErrorMsg = '请输入手机号'
        } else if (!/^1\d{10}$/.test($.trim(val))) {
          this.phoneError = true
          this.phoneErrorMsg = '请输入正确的手机号'
        } else {
          this.phoneError = false
        }
      }
    },
    components: {
      enteringStep
    },
    methods: {
      // 信息回显 =====> 已弃用
      echoData() {
        this.$root.post('/getPatientInfo', {
          user_id: this.userInfo.user_id || 0,
          doc_id: this.$route.query.doc_id,
          type: 1,
        }).then(data => {
          console.log(data);
          if (data.username != '') {
            this.realName = data.username;
            this.hasName = true;
          }
          if (data.gender) {
            this.gender = data.gender;
            this.hasGender = true;
          }
          if (data.province) {
            this.location.province = data.gender;

          }
          if (data.id_number) {
            this.IDNumber = data.id_number;
            this.hasIDNumber = true;
          }
          if (data.birthday) this.born = moment(data.birthday, 'YYYY/M').toDate();
          if (data.stature) this.height = parseFloat(data.stature);
          if (data.weight) this.weight = parseFloat(data.weight);
          if (data.allergy) {
            if (data.allergy == '否认' || data.allergy == '不确定') {
              this.allergy = data.allergy;
            } else {
              this.allergy = '有';
              this.allergyText = data.allergy;
            }
          }
          if (data.is_married != 3) {
            this.marriage = data.is_married
          }
          if (data.is_childbed != 3) {
            this.parental = data.is_childbed
          }
          if (data.nation) this.nationality = data.nation;
          if (data.job) this.job = data.job;
          if (data.mobile) {
            this.phone = data.mobile;
            this.bindedPhone = true;
          }
        })
      },
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        }
        return value;
      },
      // 确认选择性别
      pickGender() {
        if (this.hasGender) return;
        this.genderPickerShow = true;
      },
      // 确认选择所在地
      confirmLocation(value) {
        if (value) {
          this.location.province = value[0].name;
          //this.location.city = value[1].name;
        }
        this.areaPickerShow = false;
      },
      confirmGender(value) {
        this.gender = value.value;
        this.genderPickerShow = false;
      },
      showBornPicker() {
        if (!this.born) {
          this.born = new Date();
        }
        this.bornPickerShow = true
      },
      // 确认出生年月
      confirmBirthday(value) {
        this.born = value;
        this.bornPickerShow = false;
      },
      // 确认过敏史
      confirmAllergy(value) {
        this.allergy = value;
        this.allergyPickerShow = false;
      },
      // 确认婚况 =====> 已弃用
      confirmMarriage(value) {
        this.marriage = value.value;
        this.marriagePickerShow = false;
      },
      // 确认生育情况 =====> 已弃用
      confirmParental(value) {
        this.parental = value.value;
        this.parentalPickerShow = false;
      },
      // 确认民族 =====> 已弃用
      confirmNationality(value) {
        this.nationality = value.name;
        this.nationalityPickerShow = false;
      },
      // 确认职业 =====> 已弃用
      confirmJob(value) {
        this.job = value;
        this.jobPickerShow = false;
      },
      // 获取验证码 倒计时
      countdown() {
        if (this.phone == '' || this.phoneError) {
          this.$notify('请输入正确的手机号');
          return;
        };
        this.$root.post('/sendPhoneCode', {
          mobile: this.phone
        }).then(data => {
          console.log(data);
          if (data.status == 1) {
            countDownAction();
          } else {
            this.$notify(data.msg);
          }
        })
        let countDownAction = () => {
          this.time = 60;
          this.countDownTimer = null;
          this.sandingCode = true;
          let timeDown = () => {
            this.time -= 1;
            if (this.time <= 0) {
              clearInterval(this.countDownTimer);
              this.sandingCode = false;
            }
          }
          this.countDownTimer = setInterval(timeDown, 1000);
        }
      },
      codeChange(e) {
        if (this.code.length > 6) {
          this.code = this.code.slice(0, 6);
        }
      },
      sendMessage(doc_id) {
        let _this = this;
        this.$root.post('/createNewDocMsg', {
          pat_id: this.userInfo.user_id,
          doc_id: doc_id
        }).then(data => {
          _this.$router.replace('/patient');
        });
      },
      nextStep() {
        // 表单验证
        if (!this.realName || this.realNameError) {
          this.$notify(this.realNameErrorMsg);
          return;
        }
        if (!this.gender) {
          this.$notify('请选择性别');
          return;
        }
        if (!this.location.province) {
          this.$notify('请选择所在地');
          return;
        }
       if(!this.IDNumber || this.IDNumberError) {
          this.$notify(this.IDNumberErrorMsg);
         return;
        }
        if (!this.born) {
          this.$notify('请选择出生年月');
          return;
        }
        // if(!this.height) {
        //   this.$notify('请输入身高');
        //   return;
        // }
        // if(!this.weight) {
        //   this.$notify('请输入体重');
        //   return;
        // }
        if (!this.allergy) {
          this.$notify('请选择过敏史');
          return;
        }
        if (this.allergy == '有' && !this.allergyText) {
          this.$notify('请填写过敏史说明');
          return;
        }
        if (!this.phone || this.phoneError) {
          this.$notify(this.phoneErrorMsg);
          return;
        }
        if (!this.bindedPhone && !this.code) {
          this.$notify('请输入正确的验证码');
          return;
        }
        this.submitting = true;
        let postData = {
          user_id: this.userInfo.user_id || 0,
          user_token: this.userInfo.user_token,
          doc_id: this.$route.query.doc_id,
          role: 2,
          username: this.realName,
          gender: this.gender,
          id_number: this.IDNumber,
          birthday: moment(this.born).format('YYYY/M'),
          // stature: this.height,
          // weight: this.weight,
          allergy: (this.allergy == '否认' || this.allergy == '不确定') ? this.allergy : this.allergyText,
          // is_married: this.marriage ? this.marriage : 3,
          // is_childbed: this.parental ? this.parental : 3,
          // nation: this.nationality,
          // job: this.job,
          province: this.location.province,
          mobile: this.phone,
          code: this.code,
        }
        // 如果手机号为已绑定，则不发送验证码字段 =====> 已弃用
        if (this.bindedPhone) {
          delete postData.code;
        }
        this.$root.post('/register', postData).then(data => {
          console.log(data);
          this.submitting = false;
          if (data.status == 1) {
            // 更新本地用户信息
            this.userInfo.user_id = data.user_id;
            this.userInfo.avatar = data.avatar;
            this.userInfo.token = data.token;
            this.userInfo.role = this.role;
            this.userInfo.gender = this.gender;
            store.set('userInfo', this.userInfo);
            this.$store.commit('setUserInfo', this.userInfo);
            if (this.userInfo.token) {
              // 初始化IM
              let _this = this;
              this.$root.IMInit(this.userInfo.token, {
                connectSuccess() {
                  _this.sendMessage(data.bind_docid);

                }
              });
            } else {
              this.$notify('未获取到token');
            }
            // this.$router.push({path: '/patient/medical-record', query: {private_id: data.private_id, doc_id: this.$route.query.doc_id}})
          } else {
            this.$notify(data.msg);
          }
        })
      }
    },
    filters: {
      sexFilter(value) {
        if (value == 1) {
          return '男'
        } else if (value == 2) {
          return '女'
        } else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Entering/baseinfo.vue